import { createSlice } from "@reduxjs/toolkit";

import {
  getTenantThunk,
  createTenantThunk,
  updateTenantThunk,
  deleteTenantThunk,
} from "state/action/tenant";

// Initial state
const initialState = {
  // Get Tenant inisial state
  getTenant: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create Tenant inisial state
  createTenant: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update Tenant inisial state
  updateTenant: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete Tenant inisial state
  deleteTenant: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createTenantInputBody: {
    fullname: "",
    tenant_number: "",
    contact_number: "",
    tenant_category: "",
    term: "",
    currency: "",
    marketing: "",
    billing: "",
    family_card: "",
    tenant_type: "",
    address: "",
    email: "",
    tax_information_type: "",
    tax_name: "",
    tax_address: "",
    NPWP: "",
    personal_id: "",
    transaction_code: "",
    isPPH: false,
    company: "",
  },
  // Tenant object value
  tenant_object_value: "",
};

export const tenantSlice = createSlice({
  name: "Tenant",
  initialState,
  reducers: {
    setGetTenantObjectValue: (state, action) => {
      return {
        ...state,
        tenant_object_value: action.payload,
      };
    },
    // note: clear state
    setClearGetTenantObjectValue: (state, _) => {
      return {
        ...state,
        tenant_object_value: "",
      };
    },
    setClearGetTenant: (state, _) => {
      return {
        ...state,
        getTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateTenant: (state, _) => {
      return {
        ...state,
        createTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setCreateTenantInputBody: (state, action) => {
      return {
        ...state,
        createTenantInputBody: action.payload,
      };
    },
    setClearCreateTenantInputBody: (state, _) => {
      return {
        ...state,
        createTenantInputBody: {
          fullname: "",
          tenant_number: "",
          contact_number: "",
          tenant_category: "",
          term: "",
          currency: "",
          marketing: "",
          billing_no: "",
          family_card: "",
          tenant_type: "",
          address: "",
          phone: "",
          email: "",
          tax_information_type: "",
          tax_name: "",
          tax_address: "",
          NPWP: "",
          personal_id: "",
          expired_passport_date: null,
          transaction_code: "",
          isPPH: false,
        },
      };
    },
    setClearUpdateTenant: (state, _) => {
      return {
        ...state,
        updateTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteTenant: (state, _) => {
      return {
        ...state,
        deleteTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllTenantState: (state, _) => {
      return {
        ...state,
        // Get Tenant inisial state
        getTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create Tenant inisial state
        createTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update Tenant inisial state
        updateTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete Tenant inisial state
        deleteTenant: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Tenant object value
        tenant_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get Tenant reducer
      .addCase(getTenantThunk.pending, (state, _) => {
        return {
          ...state,
          getTenant: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getTenantThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getTenant: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getTenantThunk.rejected, (state, action) => {
        return {
          ...state,
          getTenant: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create Tenant reducer
      .addCase(createTenantThunk.pending, (state, _) => {
        return {
          ...state,
          createTenant: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createTenantThunk.fulfilled, (state, action) => {
        return {
          ...state,
          createTenant: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createTenantThunk.rejected, (state, action) => {
        return {
          ...state,
          createTenant: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update Tenant reducer
      .addCase(updateTenantThunk.pending, (state, _) => {
        return {
          ...state,
          updateTenant: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateTenantThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateTenant: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateTenantThunk.rejected, (state, action) => {
        return {
          ...state,
          updateTenant: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const tenantAction = {
  ...tenantSlice.actions,
  getTenantThunk,
  createTenantThunk,
  updateTenantThunk,
  deleteTenantThunk,
};

export function selectTenantObjectValue(state) {
  return state?.tenant?.tenant_object_value;
}

export function selectTenant(state) {
  return state?.tenant;
}

export default tenantSlice.reducer;
